import React from "react";
import Slider from "react-slick";
import "./slick.css";
import "./slick-theme.css";
import images from "./data.js"

export default function SimpleSlider() {
var settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
  return (
    <>
      <Slider {...settings}>
        {images.map((image,i)=><img src={image} key={i}/>)}
      </Slider>
    </>
  );
}
